import { AbiItem } from 'web3-utils'
import UniversalProfile from '@lukso/lsp-smart-contracts/artifacts/UniversalProfile.json'
import assert from 'assert'

export const setDataABI: AbiItem[] = (UniversalProfile.abi as AbiItem[]).filter(
  ({ name }) => name === 'setData' || name === 'setDataBatch'
)

const _specificSetDataBatchABI: AbiItem | undefined = (
  UniversalProfile.abi as AbiItem[]
).find(({ name }) => name === 'setDataBatch')
assert(_specificSetDataBatchABI, 'setDataBatch ABI not found')
export const specificSetDataBatchABI = _specificSetDataBatchABI
